const { __, __x } = JIX.Gettext;

export default {
    title: () => __("Persontypetest"),
    subtitle: () => __("Det er vigtigt, at du ikke tænker på de krav, der bliver stillet til dig privat eller i dit arbejde, men i højere grad forsøger at spørge dig selv, hvad du egentlig foretrækker, når du frit kan vælge."),
    goBack: () => __("Forrige spørgsmål"),
    frediFalk: () => __("Spørgsmålene i testen er udarbejdet i samarbejde med Fredi Falk Vogelius, Ba.Sc.E.E. og ICF professionel certificeret coach"),
    completed: () => __("Gennemført"),
};
